import React from 'react'

export default ({ x, y, width, height }) => (
    <rect className='paddle' x={x} y={y} width={width} height={height} />
)